import createSelector from "../../utils/reselect";

const invoiceRegistryStateData = (state) => {
  const { invoiceRegistry } = state;
  return invoiceRegistry || {};
};

export const getError = createSelector(
  invoiceRegistryStateData,
  (invoiceRegistry) => invoiceRegistry.get("error")
);

export const invoiceRegistryPagination = createSelector(
  invoiceRegistryStateData,
  (invoiceRegistry) => invoiceRegistry.get("invoiceRegistryPagination")
);

export const invoiceRegistry = createSelector(
  invoiceRegistryStateData,
  (invoiceRegistry) => invoiceRegistry.get("invoiceRegistry")
);

export const invoiceRegistryLoading = createSelector(
  invoiceRegistryStateData,
  (invoiceRegistry) => invoiceRegistry.get("invoiceRegistryLoading")
);

export const invoiceRegistriesLoading = createSelector(
  invoiceRegistryStateData,
  (invoiceRegistry) => invoiceRegistry.get("pageLoading")
);
